/*
 * @Description: 
 * @Author: 唐胜建
 * @Date: 2021-11-19 14:17:12
 * @LastEditTime: 2021-11-19 14:24:24
 */
import { VueExtension } from '../../utils/extensions/vue';
import Collapse from './collapse.jsx';
import './collapse.scss';

VueExtension.WithInstall(Collapse);

export default Collapse;
